import { render, staticRenderFns } from "./riskAssessmentKind.vue?vue&type=template&id=4baccf26"
import script from "./riskAssessmentKind.vue?vue&type=script&lang=js"
export * from "./riskAssessmentKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports